import type { CustomIconProps } from '../types';

const GiftIcon = ({ width, height, dataTestId }: CustomIconProps): JSX.Element => (
    <svg
        data-testid={dataTestId}
        width={width ?? '26'}
        height={height ?? '26'}
        viewBox="0 0 26 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M21.0357 4.03769C21.0357 7.60736 15.3437 8.20254 13 8.5C13 4.93033 14.0045 2.25317 16.0134 1.36105C18.0223 0.468928 21.0357 1.18231 21.0357 4.03769Z"
            stroke="#1A1A1A"
            strokeWidth="1.2"
        />
        <path
            d="M4.96429 4.03769C4.96429 7.60736 10.6563 8.20254 13 8.5C13 4.93033 11.9955 2.25317 9.98661 1.36105C7.97768 0.468928 4.96429 1.18231 4.96429 4.03769Z"
            stroke="#1A1A1A"
            strokeWidth="1.2"
        />
        <rect
            x="1"
            y="7.3999"
            width="24"
            height="4.8"
            fill="white"
            stroke="#1A1A1A"
            strokeWidth="1.2"
        />
        <rect
            x="2.71094"
            y="12.2002"
            width="20.5714"
            height="12.8"
            fill="white"
            stroke="#1A1A1A"
            strokeWidth="1.2"
        />
        <path
            d="M16.4297 25L16.4297 7.4L9.57254 7.4L9.57254 25L16.4297 25Z"
            fill="white"
            stroke="#1A1A1A"
            strokeWidth="1.2"
        />
    </svg>
);

export default GiftIcon;
